interface SVGIconProps {
  width?: string;
  height?: string;
  color?: string;
}
export const MoneyIcon = ({
  width,
  height = "100%",
  color = "black",
}: SVGIconProps) => (
  <svg
    viewBox="0 0 15 15"
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.28516 14.126C8.2513 14.126 9.16048 13.9414 10.0127 13.5723C10.8649 13.2077 11.6169 12.6995 12.2686 12.0479C12.9202 11.3962 13.4307 10.6442 13.7998 9.79199C14.1689 8.93978 14.3535 8.0306 14.3535 7.06445C14.3535 6.09831 14.1689 5.18913 13.7998 4.33691C13.4307 3.4847 12.9202 2.73503 12.2686 2.08789C11.6169 1.4362 10.8649 0.925781 10.0127 0.556641C9.16048 0.1875 8.24902 0.00292969 7.27832 0.00292969C6.31217 0.00292969 5.40299 0.1875 4.55078 0.556641C3.70312 0.925781 2.95345 1.4362 2.30176 2.08789C1.65462 2.73503 1.14648 3.4847 0.777344 4.33691C0.408203 5.18913 0.223633 6.09831 0.223633 7.06445C0.223633 8.0306 0.408203 8.93978 0.777344 9.79199C1.14648 10.6442 1.65462 11.3962 2.30176 12.0479C2.95345 12.6995 3.7054 13.2077 4.55762 13.5723C5.40983 13.9414 6.31901 14.126 7.28516 14.126ZM7.28516 11.0566C7.18945 11.0566 7.1097 11.027 7.0459 10.9678C6.98665 10.9085 6.95703 10.8288 6.95703 10.7285V10.2432C6.45117 10.2021 6.02051 10.0586 5.66504 9.8125C5.31413 9.56641 5.08854 9.25195 4.98828 8.86914C4.97461 8.82812 4.96322 8.78711 4.9541 8.74609C4.94954 8.70508 4.94727 8.66406 4.94727 8.62305C4.94727 8.48177 4.99056 8.36784 5.07715 8.28125C5.16829 8.1901 5.28678 8.14453 5.43262 8.14453C5.55566 8.14453 5.6582 8.17643 5.74023 8.24023C5.82227 8.29948 5.88835 8.39518 5.93848 8.52734C5.99772 8.73242 6.10938 8.90788 6.27344 9.05371C6.44206 9.19954 6.66992 9.29297 6.95703 9.33398V7.46094L6.84766 7.43359C6.25521 7.29688 5.80632 7.08952 5.50098 6.81152C5.19564 6.52897 5.04297 6.15755 5.04297 5.69727C5.04297 5.19596 5.22298 4.78581 5.58301 4.4668C5.94303 4.14779 6.40104 3.96094 6.95703 3.90625V3.43457C6.95703 3.33431 6.98665 3.25456 7.0459 3.19531C7.1097 3.13607 7.18945 3.10645 7.28516 3.10645C7.3763 3.10645 7.4515 3.13607 7.51074 3.19531C7.57454 3.25456 7.60645 3.33431 7.60645 3.43457V3.90625C8.08496 3.95638 8.49056 4.10449 8.82324 4.35059C9.15592 4.59668 9.37012 4.9043 9.46582 5.27344C9.47949 5.3099 9.48861 5.34863 9.49316 5.38965C9.50228 5.43066 9.50684 5.47168 9.50684 5.5127C9.50684 5.64941 9.46126 5.76107 9.37012 5.84766C9.28353 5.93424 9.16732 5.97754 9.02148 5.97754C8.78906 5.97754 8.62044 5.85221 8.51562 5.60156C8.44727 5.39193 8.33561 5.22331 8.18066 5.0957C8.02572 4.96354 7.83431 4.87695 7.60645 4.83594V6.60645L7.76367 6.64062C8.37891 6.75456 8.84147 6.95736 9.15137 7.24902C9.46582 7.54069 9.62305 7.92806 9.62305 8.41113C9.62305 8.95345 9.43164 9.38411 9.04883 9.70312C8.66602 10.0176 8.18522 10.2021 7.60645 10.2568V10.7285C7.60645 10.8288 7.57454 10.9085 7.51074 10.9678C7.4515 11.027 7.3763 11.0566 7.28516 11.0566ZM6.95703 6.44238V4.8291C6.68815 4.87012 6.47396 4.96582 6.31445 5.11621C6.15951 5.26204 6.08203 5.43294 6.08203 5.62891C6.08203 5.82031 6.14811 5.97982 6.28027 6.10742C6.41699 6.23503 6.62663 6.34212 6.90918 6.42871L6.95703 6.44238ZM7.60645 7.61816V9.33398C7.93457 9.29753 8.17839 9.2041 8.33789 9.05371C8.50195 8.89876 8.58398 8.70964 8.58398 8.48633C8.58398 8.28125 8.52018 8.11263 8.39258 7.98047C8.26953 7.84375 8.05306 7.73438 7.74316 7.65234L7.60645 7.61816Z"
      fill={
        color
          ? color === "bluegradient"
            ? "url(#paint0_linear_586_2224)"
            : color === "purplegradient"
              ? "url(#paint0_linear_586_2224)"
              : color
          : "black"
      }
    />
    <defs>
      {color === "purplegradient" && (
        <linearGradient
          id="paint0_linear_586_2224"
          x1="0.2"
          y1="-4"
          x2="26.6022"
          y2="2.83473"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C72A8E" />
          <stop offset="1" stopColor="#7815DA" />
        </linearGradient>
      )}
      {color === "bluegradient" && (
        <linearGradient
          id="paint0_linear_586_2224"
          x1="-7.89109"
          y1="-5"
          x2="26.1628"
          y2="0.975647"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8E8EF2" />
          <stop offset="1" stopColor="#6911E7" />
        </linearGradient>
      )}
    </defs>
  </svg>
);
